import { styled } from '@mui/system';
import notSupportImg from './images/notSupport.png';

const Container = styled('div')(
  ({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  })
);

const Title = styled('p')(
  ({ theme }) => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 26,
    lineHeight: '36px',
    textAlign: 'center',
    color: '#1A1A1A',
    margin: '24px 0 15px 0',
    maxWidth: 300,
  })
);

const Description = styled('p')(
  ({ theme }) => ({
    maxWidth: 300,
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '17px',
    lineHeight: '24px',
    /* or 141% */
    textAlign: 'center',
    color: '#979797',
  })
);

export default function NotSupport(props: { title: string, description?: string, type?: string }) {
  const { type } = props;
  let description = 'Please update your browser to the latest version to use Alfred WebViewer.';
  if (type === 'browser') {
    description =
      'This web browser is not supported. Please use the <b>Google Chrome</b>, <b>Safari</b> or <b>Firefrox</b> browser to continue to use Alfred WebViewer.';
  }

  return (
    <Container>
      <img width='195' height='195' src={notSupportImg} alt='' />
      <Title>{props.title}</Title>
      <Description dangerouslySetInnerHTML={{ __html: props.description || description }} />
    </Container>
  );
}
